// Predicate-generating function. Often useful outside of Underscore.
export default function constant(value) {
  return function() {
    return value;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/constant.js
// module id = 325
// module chunks = 115